$(document).ready(function () {
    // Check if there is a oversize present
    var $oversize = $('.oversize');
    if ($oversize.length > 0) {       
        // Check if the video should be used      
        if($oversize.data("video-src")){
            // Check if the viewport is bigger than 900
            var viewportWidth = $(window).width();
            if(viewportWidth > 900){
                var videoSrc = $oversize.data("video-src");
                var video = "<video muted class='hero-video' autoplay='true' loop='true' preload='auto'>"+
                "<source src='" + videoSrc + "'>" +
                "<img src=''></video>";
                $oversize.find('.crop').prepend(video);
            }
        }
    };
});